export default __webpack_public_path__ + "static/meowth-d2c39834f33c78cbaa74e5c034dd6b64.png";